var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-m"},[_c('img',{attrs:{"src":"https://resource.rcclchina.com.cn/Home/mb_loading.gif","alt":""}})])
}]

export { render, staticRenderFns }